import React, { Fragment, useState } from "react";
import { useAppState } from "src/StateHandlers/AppStateHandler";
import Drawer from "src/Components/Custom/Drawer/Drawer";
import UserNavBar from "src/Components/Custom/UserNavBar/UserNavBar";
import BookmarkPosts from "./Components/BookmarkPosts/BookmarkPosts";
import Home from "./Components/Home/Home";
import HiddenPosts from "./Components/HiddenPosts/HiddenPosts";
import MyPosts from "./Components/MyPosts/MyPosts";
import Sales from "./Components/Sales/Sales";
import Groups from "./Components/Groups/Groups";
import Business from "./Components/Business/Business";
import Chat from "./Components/Chat/Chat";
import { useRouteMatch } from "react-router-dom";

function DashboardPage() {
  const [{ showSidebar }] = useAppState();
  const [modalVisibility, setModalVisibility] = useState<boolean>(false);
  const [search, setSearch] = useState<string>('');
  const { path } = useRouteMatch();
  return (
    <Fragment>
      <div className={showSidebar ? "" : "toggle_class"}>
        <UserNavBar setModalVisibility={setModalVisibility} setSearch={setSearch} search={search} />
        <div className="wrapper">
          <Drawer />
          {(path === '/home' || path === '/home/:id') ?
            <Home modalVisibility={modalVisibility} setModalVisibility={setModalVisibility} search={search} />
            : <></>
          }
          {(path === '/sales' || path === '/sales/:id') ?
            <Sales modalVisibility={modalVisibility} setModalVisibility={setModalVisibility} />
            : <></>
          }
          {path === '/business' ?
            <Business modalVisibility={modalVisibility} setModalVisibility={setModalVisibility} />
            : <></>
          }
          {(path === '/bookmarks' || path === '/bookmarks/:id') ?
            <BookmarkPosts />
            : <></>
          }
          {(path === '/messages' || path === '/messages/:id') ?
            <Chat />
            : <></>
          }
          {(path === '/my-posts' || path === '/my-posts/:id') ?
            <MyPosts />
            : <></>
          }
          {(path === '/hidden-posts' || path === '/hidden-posts/:id') ?
            <HiddenPosts />
            : <></>
          }
          {(path === '/groups' || path === '/groups/:id' || path === '/groups/:id/:postId') ?
            <Groups />
            : <></>
          }
        </div>
      </div>
    </Fragment>
  );
}

export default DashboardPage;
